module.exports = __webpack_public_path__ + "static/media/3 07 Tulleord Gjalte er feil-norming.81ca3ba0.mp3";